"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _system = require("@mui/system");
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _Breadcrumbs = _interopRequireDefault(require("@mui/material/Breadcrumbs"));
var _Link = _interopRequireDefault(require("@mui/material/Link"));
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon"));
var _MoreVert = _interopRequireDefault(require("@mui/icons-material/MoreVert"));
var _DeleteForever = _interopRequireDefault(require("@mui/icons-material/DeleteForever"));
var _Download = _interopRequireDefault(require("@mui/icons-material/Download"));
var _ArrowBack = _interopRequireDefault(require("@mui/icons-material/ArrowBack"));
var _FolderOutlined = _interopRequireDefault(require("@mui/icons-material/FolderOutlined"));
var _DescriptionOutlined = _interopRequireDefault(require("@mui/icons-material/DescriptionOutlined"));
var _PictureAsPdfOutlined = _interopRequireDefault(require("@mui/icons-material/PictureAsPdfOutlined"));
var _ImageOutlined = _interopRequireDefault(require("@mui/icons-material/ImageOutlined"));
var _LockOutlined = _interopRequireDefault(require("@mui/icons-material/LockOutlined"));
var _Visibility = _interopRequireDefault(require("@mui/icons-material/Visibility"));
var _Button = _interopRequireDefault(require("../../components/Button"));
var _NewModal = _interopRequireDefault(require("../../components/Modals/NewModal"));
var _TextInput = _interopRequireDefault(require("../../components/TextFields/TextInput"));
var _colors = _interopRequireDefault(require("../../theme/colors"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var VisuallyHiddenInput = (0, _system.styled)('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});
var TableRowCustom = (0, _system.styled)('TableRow')(function (_ref) {
  var theme = _ref.theme;
  return {
    '&:hover': {
      backgroundColor: "".concat(_colors["default"].lightGrey, " !important")
    }
  };
});

/**
 * @param type
 * @param id
 * @param parentFolder
 * @param listFiles
 * @param uploadFile
 * @param downloadFile
 * @param makePrivate
 * @param makePublic
 * @param createFolder
 * @param removeFile
 * @param dispatch
 * @param isMasterSite
 * @param isLocked
 * @param noContainer
 * @param style
 * @returns {JSX.Element}
 * @constructor
 */
var Files = function Files(_ref2) {
  var type = _ref2.type,
    id = _ref2.id,
    parentFolder = _ref2.parentFolder,
    listFiles = _ref2.listFiles,
    uploadFile = _ref2.uploadFile,
    downloadFile = _ref2.downloadFile,
    makePrivate = _ref2.makePrivate,
    makePublic = _ref2.makePublic,
    createFolder = _ref2.createFolder,
    removeFile = _ref2.removeFile,
    dispatch = _ref2.dispatch,
    isMasterSite = _ref2.isMasterSite,
    _ref2$isLocked = _ref2.isLocked,
    isLocked = _ref2$isLocked === void 0 ? false : _ref2$isLocked,
    _ref2$noContainer = _ref2.noContainer,
    noContainer = _ref2$noContainer === void 0 ? false : _ref2$noContainer,
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? {} : _ref2$style;
  var styles = {
    container: _objectSpread({
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      boxShadow: noContainer ? null : 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
      padding: noContainer ? 0 : "20px 30px",
      minHeight: 150,
      background: '#FFF',
      borderRadius: 10
    }, style),
    headerContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      height: 50,
      width: '100%'
    },
    filenameContainer: {
      cursor: 'pointer'
    },
    breadcrumbContainer: {
      flex: 1
    }
  };
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    files = _useState2[0],
    setFiles = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    folders = _useState4[0],
    setFolders = _useState4[1];
  var _useState5 = (0, _react.useState)("/"),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    parentPath = _useState6[0],
    setparentPath = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    breadcrumbs = _useState8[0],
    setBreadcrumbs = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    createFolderOpen = _useState10[0],
    toggleCreateFolder = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    folderName = _useState12[0],
    setFolderName = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    fileToDelete = _useState14[0],
    setFileToDelete = _useState14[1];
  var _useState15 = (0, _react.useState)(null),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    anchorEl = _useState16[0],
    setAnchorEl = _useState16[1];
  var _useState17 = (0, _react.useState)(null),
    _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
    openedMenu = _useState18[0],
    setOpenedMenu = _useState18[1];
  var clearFiles = function clearFiles() {
    setparentPath('/');
    setBreadcrumbs([]);
  };
  var selectFolder = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(path) {
      var temp;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            temp = path.split('/');
            _context.next = 3;
            return setBreadcrumbs([].concat((0, _toConsumableArray2["default"])(breadcrumbs), [{
              title: temp[temp.length - 2],
              path: path
            }]));
          case 3:
            setparentPath(path);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function selectFolder(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var goBack = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var currentBreadcrumbs, nextState;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            currentBreadcrumbs = (0, _toConsumableArray2["default"])(breadcrumbs);
            nextState = currentBreadcrumbs[currentBreadcrumbs.length - 2];
            currentBreadcrumbs.splice(currentBreadcrumbs.length - 1, 1);
            setparentPath(nextState ? nextState.path : '/');
            setBreadcrumbs(currentBreadcrumbs);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function goBack() {
      return _ref4.apply(this, arguments);
    };
  }();
  var selectBreadcrumb = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(breadcrumb) {
      var index;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            // find the selected breadcrumb in the list of past paths
            index = breadcrumbs.findIndex(function (obj) {
              return obj.title === breadcrumb.title;
            }); // set the new parent directory to the selected breadcrumb path
            setparentPath(breadcrumbs[index].path);

            // remove all breadcrumbs after the selected breadcrumb
            breadcrumbs.splice(index + 1, breadcrumbs.length - index - 1);

            // set the new breadcrumbs on the page
            setBreadcrumbs(breadcrumbs);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function selectBreadcrumb(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var listDirectory = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var path, data;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            path = null;
            if (parentPath !== '/') {
              path = parentPath.split("".concat(id, "/").concat(parentFolder, "/"))[1];
            }
            _context4.next = 4;
            return dispatch(listFiles(type, id, parentFolder, path));
          case 4:
            data = _context4.sent;
            setFiles(data.files);
            setFolders(data.folders);
          case 7:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function listDirectory() {
      return _ref6.apply(this, arguments);
    };
  }();
  var _handleFileUpload = /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(event) {
      var file, success;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            file = event.target.files[0];
            if (file) {
              _context5.next = 4;
              break;
            }
            console.log("No file selected.");
            return _context5.abrupt("return");
          case 4:
            _context5.next = 6;
            return dispatch(uploadFile(type, id, parentFolder, file, parentPath === '/' ? null : parentPath));
          case 6:
            success = _context5.sent;
            if (success) {
              listDirectory();
            }
          case 8:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function _handleFileUpload(_x3) {
      return _ref7.apply(this, arguments);
    };
  }();
  var _downloadFile = /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(path) {
      var url;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return dispatch(downloadFile(type, id, parentFolder, path));
          case 2:
            url = _context6.sent;
            window.open(url, "_blank");
          case 4:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function _downloadFile(_x4) {
      return _ref8.apply(this, arguments);
    };
  }();
  var _makePrivate = /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(path) {
      var success;
      return _regenerator["default"].wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return dispatch(makePrivate(type, id, path));
          case 2:
            success = _context7.sent;
            if (success) {
              listDirectory();
            }
          case 4:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function _makePrivate(_x5) {
      return _ref9.apply(this, arguments);
    };
  }();
  var _makePublic = /*#__PURE__*/function () {
    var _ref10 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(path) {
      var success;
      return _regenerator["default"].wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return dispatch(makePublic(type, id, path));
          case 2:
            success = _context8.sent;
            if (success) {
              listDirectory();
            }
          case 4:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function _makePublic(_x6) {
      return _ref10.apply(this, arguments);
    };
  }();
  var _sortFolders = function _sortFolders(folders) {
    folders.sort(function (a, b) {
      var aSegments = a.Prefix.split('/');
      var aName = aSegments[aSegments.length - 2];
      var bSegments = b.Prefix.split('/');
      var bName = bSegments[bSegments.length - 2];
      return aName.localeCompare(bName);
    });
    return folders;
  };
  var _sortFiles = function _sortFiles(files) {
    files.sort(function (a, b) {
      // Convert date strings to Date objects to compare
      var dateA = new Date(a.LastModified);
      var dateB = new Date(b.LastModified);
      return dateB - dateA; // for descending order
    });
    return files;
  };
  var _capitalizeFirstLetter = function _capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  // list the parent directory on load
  (0, _react.useEffect)(function () {
    listDirectory();
  }, [id, parentPath]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "".concat(type, "-files"),
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.headerContainer
  }, breadcrumbs.length > 0 && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    variant: "plain",
    onClick: goBack
  }, /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], {
    sx: {
      fontSize: 18
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.breadcrumbContainer
  }, breadcrumbs.length === 0 ? /*#__PURE__*/_react["default"].createElement(_Breadcrumbs["default"], {
    "aria-label": "breadcrumbs",
    sx: {
      padding: 0,
      cursor: 'pointer'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    mediumLarge: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].titles.files))) : /*#__PURE__*/_react["default"].createElement(_Breadcrumbs["default"], {
    "aria-label": "breadcrumbs",
    sx: {
      padding: 0,
      cursor: 'pointer'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    onClick: clearFiles,
    style: {
      textDecoration: 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    mediumLarge: true,
    light: true
  }, _i18n["default"].t(_tokens["default"].titles.files))), breadcrumbs.map(function (item, i) {
    if (i === breadcrumbs.length - 1) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      onClick: function onClick() {
        return selectBreadcrumb(item);
      },
      style: {
        textDecoration: 'none'
      }
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      mediumLarge: true,
      light: true
    }, item.title));
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    mediumLarge: true,
    bold: true
  }, breadcrumbs[breadcrumbs.length - 1].title))), !isLocked && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    color: "primary",
    onClick: function onClick() {
      return toggleCreateFolder(true);
    },
    customStyle: {
      marginRight: "10px"
    }
  }, _i18n["default"].t(_tokens["default"].buttons.createFolder)), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    primary: true,
    color: "primary",
    component: "label"
  }, _i18n["default"].t(_tokens["default"].buttons.uploadFile), /*#__PURE__*/_react["default"].createElement(VisuallyHiddenInput, {
    type: "file",
    id: "fileInput",
    name: "file",
    onChange: _handleFileUpload
  })))), /*#__PURE__*/_react["default"].createElement(_Table["default"], {
    hoverRow: true,
    sx: {
      marginTop: "20px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_TableHead["default"], null, /*#__PURE__*/_react["default"].createElement(_TableRow["default"], null, /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
    align: "left",
    sx: {
      fontWeight: 'bold'
    }
  }, _i18n["default"].t(_tokens["default"].labels.files.tableHeadings.name)), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
    align: "center",
    sx: {
      fontWeight: 'bold'
    }
  }, _i18n["default"].t(_tokens["default"].labels.files.tableHeadings.owner)), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
    align: "center",
    sx: {
      fontWeight: 'bold'
    }
  }, _i18n["default"].t(_tokens["default"].labels.files.tableHeadings.lastModified)), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
    align: "center",
    sx: {
      fontWeight: 'bold'
    }
  }, _i18n["default"].t(_tokens["default"].labels.files.tableHeadings.fileSize)), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], null))), /*#__PURE__*/_react["default"].createElement(_TableBody["default"], null, _sortFolders(folders).map(function (folder) {
    var pathSegments = folder.Prefix.split('/');
    var name = pathSegments[pathSegments.length - 2];
    var createdBy = "-";
    var lastModified = "-";
    var fileSize = "-";
    return /*#__PURE__*/_react["default"].createElement(_TableRow["default"], {
      key: folder.Prefix,
      onClick: function onClick() {
        return selectFolder(folder.Prefix);
      }
    }, /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      align: "left",
      sx: styles.filenameContainer
    }, /*#__PURE__*/_react["default"].createElement(_FolderOutlined["default"], {
      sx: {
        marginRight: "10px",
        verticalAlign: 'bottom'
      }
    }), name), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      align: "center"
    }, createdBy), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      align: "center"
    }, lastModified), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      align: "center"
    }, fileSize), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], null));
  }), _sortFiles(files).map(function (file) {
    var isPrivate = file.accesstype === 'private';
    if (file.Size === 0) {
      return null;
    }

    // if the file is marked as private and we are on the master site then hide the file
    if (isPrivate && !isMasterSite) {
      return null;
    }
    var pathSegments = file.Key.split('/');
    var name = pathSegments[pathSegments.length - 1];
    var lastModified = dates.getLocalDisplay(file.LastModified, 'lll', _i18n["default"].locale);
    var kilobytes = Math.ceil(file.Size / 1024);
    var megabytes = (Number(file.Size) / (1024 * 1024)).toFixed(1);
    var owner = file.createdby ? _capitalizeFirstLetter(file.createdby.split('-')[0]) : '-';
    if (isPrivate && isMasterSite) {
      owner = "".concat(owner, " (Private)");
    }
    var ext = name.split('.')[1];
    var icon = /*#__PURE__*/_react["default"].createElement(_DescriptionOutlined["default"], {
      sx: {
        marginRight: "10px",
        verticalAlign: 'bottom'
      }
    });
    if (ext.toLowerCase() === 'pdf') {
      icon = /*#__PURE__*/_react["default"].createElement(_PictureAsPdfOutlined["default"], {
        sx: {
          marginRight: "10px",
          verticalAlign: 'bottom'
        }
      });
    } else if (['png', 'jpg', 'jpeg', 'gif'].includes(ext.toLowerCase())) {
      icon = /*#__PURE__*/_react["default"].createElement(_ImageOutlined["default"], {
        sx: {
          marginRight: "10px",
          verticalAlign: 'bottom'
        }
      });
    }
    var ownerDisplay = isMasterSite ? owner : owner.split(" ")[0];
    return /*#__PURE__*/_react["default"].createElement(_TableRow["default"], {
      key: file.key
    }, /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      align: "left",
      sx: styles.filenameContainer,
      onClick: function onClick() {
        return _downloadFile(file.Key);
      }
    }, icon, name), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      align: "center"
    }, isMasterSite ? ownerDisplay : _i18n["default"].t(_tokens["default"].labels.files.owners[ownerDisplay.toLowerCase()])), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      align: "center"
    }, lastModified), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      align: "center"
    }, megabytes >= 1 ? "".concat(megabytes, " MB") : "".concat(kilobytes, " KB")), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
      align: "right"
    }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      id: "menu-button-".concat(file.Key),
      "aria-controls": openedMenu === file.Key ? "menu-".concat(file.Key) : undefined,
      "aria-haspopup": "true",
      onClick: function onClick() {
        return setOpenedMenu(openedMenu === file.Key ? null : file.Key);
      }
    }, /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], null)), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
      id: "menu-".concat(file.Key),
      anchorEl: document.getElementById("menu-button-".concat(file.Key)),
      open: openedMenu === file.Key,
      onClose: function onClose() {
        return setOpenedMenu(null);
      },
      MenuListProps: {
        'aria-labelledby': "menu-button-".concat(file.Key)
      }
    }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      onClick: function onClick() {
        setOpenedMenu(null);
        _downloadFile(file.Key);
      }
    }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(_Download["default"], null)), ' ', _i18n["default"].t(_tokens["default"].labels.files.menu.open)), !isLocked && /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      onClick: function onClick() {
        setOpenedMenu(null);
        setFileToDelete(file.Key);
      }
    }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(_DeleteForever["default"], null)), ' ', _i18n["default"].t(_tokens["default"].labels.files.menu["delete"])))));
  }))), /*#__PURE__*/_react["default"].createElement(_NewModal["default"], {
    title: _i18n["default"].t(_tokens["default"].titles.areYouSure),
    small: true,
    open: fileToDelete,
    onClose: function onClose() {
      return setFileToDelete(null);
    },
    primaryButton: {
      label: _i18n["default"].t(_tokens["default"].labels.files.menu["delete"]),
      color: "error",
      onClick: function () {
        var _onClick = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
          var success;
          return _regenerator["default"].wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return dispatch(removeFile(type, id, parentFolder, fileToDelete));
              case 2:
                success = _context9.sent;
                if (success) {
                  setFileToDelete(null);
                  listDirectory();
                }
              case 4:
              case "end":
                return _context9.stop();
            }
          }, _callee9);
        }));
        function onClick() {
          return _onClick.apply(this, arguments);
        }
        return onClick;
      }()
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true
  }, _i18n["default"].t(_tokens["default"].labels.files.deleteMessage))), /*#__PURE__*/_react["default"].createElement(_NewModal["default"], {
    title: _i18n["default"].t(_tokens["default"].buttons.createFolder),
    small: true,
    open: createFolderOpen,
    onClose: function onClose() {
      return toggleCreateFolder(false);
    },
    primaryButton: {
      label: _i18n["default"].t(_tokens["default"].buttons.create),
      onClick: function () {
        var _onClick2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
          var success;
          return _regenerator["default"].wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return dispatch(createFolder(type, id, parentFolder, folderName, parentPath === '/' ? null : parentPath));
              case 2:
                success = _context10.sent;
                if (success) {
                  toggleCreateFolder(false);
                  listDirectory();
                }
              case 4:
              case "end":
                return _context10.stop();
            }
          }, _callee10);
        }));
        function onClick() {
          return _onClick2.apply(this, arguments);
        }
        return onClick;
      }()
    }
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: _i18n["default"].t(_tokens["default"].labels.files.inputs.folderName),
    value: folderName,
    onChange: function onChange(e) {
      return setFolderName(e.target.value);
    },
    variant: "outlined",
    fullWidth: true,
    autoFocus: true
  })));
};
var _default = exports["default"] = Files;